export default {
  namespaced: true,

  state: () => ({
    isLoading: false,
    isSearchShown: false,
    searchSuggestions: {
      categories: [],
      hints: [],
      products: [],
      taps: [],
    },
  }),

  getters: {
    isLoading: (state) => state.isLoading,
    isSearchShown: (state) => state.isSearchShown,
    searchSuggestions: (state) => state.searchSuggestions,
  },

  actions: {
    toggleSearch({ commit, getters }) {
      commit('setSearchShown');

      if (!getters.isSearchShown) {
        commit('resetSearchSuggestions');
      }
    },

    async loadSuggestions({ commit }, { query }) {
      commit('setLoading', true);
      const result = await this.$apiBFF.getSearchSuggestions({ query });

      commit('setSearchSuggestions', result);
      commit('setLoading', false);
    },
  },

  mutations: {
    setSearchShown: (state) => {
      state.isSearchShown = !state.isSearchShown;
    },

    setSearchSuggestions: (state, suggestions) => {
      state.searchSuggestions = {
        ...state.searchSuggestions,
        ...suggestions,
      };
    },

    resetSearchSuggestions: (state) => {
      state.searchSuggestions = {
        categories: [],
        hints: [],
        products: [],
        taps: [],
      };
    },

    setLoading: (state, value) => {
      state.isLoading = value;
    },
  },
};
